import { NativeAnimation } from "./NativeAnimation.mjs";
class NativeAnimationWrapper extends NativeAnimation {
  constructor(animation) {
    super();
    this.animation = animation;
    animation.onfinish = () => {
      this.finishedTime = this.time;
      this.notifyFinished();
    };
  }
}
export {
  NativeAnimationWrapper
};
